<template>
  <footer>
    <div class="container-fluid bg-green shadow-mild text-light">
      <div class="container">
        <div class="row py-5">
          <div class="col-sm-12 col-md-3">
            <h5 class="mb-3">
              <strong>Get in touch</strong>
            </h5>
            <ul class="list-unstyled">
              <li>
                <router-link
                  class="text-light"
                  to="/contact"
                >
                  <u>Send us a message</u>
                </router-link>
              </li>
              <li>
                <a
                  class="text-light"
                  href="tel:1-888-856-0137"
                >1-888-856-0137</a>
              </li>
              <li>P.O. Box 980 Vidalia, GA 30475</li>
              <li>
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      class="text-light"
                      href="https://www.facebook.com/foodfitnessfirst"
                      target="_blank"
                    ><i class="fab fa-facebook-square" /></a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      class="text-light"
                      href="https://twitter.com/FoodFitness1st"
                      target="_blank"
                    ><i class="fab fa-twitter-square" /></a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      class="text-light"
                      href="https://www.instagram.com/FoodFitnessFirst/"
                      target="_blank"
                    ><i class="fab fa-instagram" /></a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="col-sm-6 col-md-3">
            <h5 class="mb-3">
              <strong>Links</strong>
            </h5>
            <ul class="list-unstyled">
              <li>
                <router-link
                  class="text-light"
                  to="/definitions"
                >
                  Definitions
                </router-link>
              </li>
              <li>
                <router-link
                  class="text-light"
                  to="/about"
                >
                  About Us
                </router-link>
              </li>
              <li>
                <router-link
                  class="text-light"
                  to="/privacy"
                >
                  Privacy/Terms of Service
                </router-link>
              </li>
              <li>
                <a
                  href="https://www.foodfitnessfirstceu.com/shop"
                  class="text-light"
                  target="_blank"
                >Visit Our Store</a>
              </li>
            </ul>
          </div>
          <div class="col-sm-6 col-md-3">
            <h5 class="mb-3">
              <strong>Recent Posts</strong>
            </h5>
            <ul class="list-unstyled">
              <li
                v-for="post in posts"
                :key="post.id"
                class="text-truncate"
              >
                <router-link
                  class="text-white"
                  :to="{ name: 'post', params: { post: post.slug }}"
                >
                  {{ post.title }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-sm-6 col-md-3">
            <h5 class="mb-3">
              <strong>Recent Recipes</strong>
            </h5>
            <ul class="list-unstyled">
              <li
                v-for="recipe in recipes"
                :key="recipe.id"
                class="text-truncate"
              >
                <router-link
                  class="text-white"
                  :to="{ name: 'recipe', params: { recipe: recipe.slug }}"
                >
                  {{ recipe.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="row pb-5">
          <div class="col-6 col-sm-4 col-md-3">
            <a
              class="d-block w-100"
              href="https://apps.apple.com/us/app/food-fitness-first/id6443851000"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                class="w-100"
                src="/img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                alt="Download on the App Store"
              >
            </a>
          </div>
          <div class="col-6 col-sm-4 col-md-3">
            <a
              class="d-block w-100"
              href="https://play.google.com/store/apps/details?id=com.foodfitnessfirst.app"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                class="w-100"
                src="/img/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
              >
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white">
      <div class="row py-3">
        <div class="col-12 text-center text-dark">
          <small class="font-italic font-weight-light">
            <span
              id="footer_name"
              class="no-select"
            >©Food Fitness First, Inc®</span>
            <div
              id="footer_menu"
              style="display: none;"
              class="no-select"
            >
              <span id="dev_title">Dev Menu</span>
              <br>
              <span id="dev_hostname" />
              <hr>
              <a href="https://foodfitnessfirst.com/">Production</a><br>
              <a href="https://dev01.foodfitnessfirst.com/">Staging</a><br>
              <a href="https://fff-api.devr.env.rest/">DevR</a><br>
              <button @click="loadLocal()">Local</button>
              <hr>
              Spiral:<br>
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="/api/share-portal/core/135/!sc!#RFS">RFS</a><br>
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="/api/share-portal/core/136/!sc!#RDFS">RDFS</a><br>
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="/api/share-portal/core/137/!sc!#DFS">DFS</a><br>
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="/api/share-portal/core/138/!sc!#LSFS">LSFS</a><br>
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="/api/share-portal/core/139/!sc!#HFS">HFS</a><br>
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="/api/share-portal/core/140/!sc!#CFS">CFS</a><br>

              <div>
                <h2>Errors</h2>
                <ol>
                  <li v-for="error of errors">
                    <pre>{{ String(error) }}</pre>
                  </li>
                </ol>
              </div>
            </div>
          </small>
          <br>
          <small class="font-italic font-weight-light">
            The <strong>FOOD SPIRAL®</strong> is a registered trademark of Food Fitness First, Inc.®<br>All other trademarks and service marks are the properties of their respective owners.
          </small>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

import Posts from '../services/posts.js';
import Recipes from '../services/recipes.js';

export default {
  data () {
    return {
      posts: [],
      recipes: [],
      errors: [],
      errorListener: undefined,
    }
  },
  created () {
    this.fetchData();
    this.watchForErrors();
  },
  beforeDestroy() {
    clearInterval(this.errorListener);
  },
  methods: {
    fetchData () {
      Posts.all({page: 1, perpage: 4}).then(res => {
        this.posts = res.data;
      });

      Recipes.all({page: 1, perpage: 4}).then(res => {
        this.recipes = res.data;
      });
    },
    watchForErrors() {
      this.errorListener = setInterval(() => {
        this.errors = window.APP_LOGGED_ERRORS;
      }, 300);
    },
    loadLocal() {
      location.href = prompt('What is the local URL?');
    }
  },
}

document.onreadystatechange = function () {
  if (document.readyState == "interactive") {
    document.querySelector('#footer_name').addEventListener("click", function(event) {
      console.log('click');
      if ( globalThis.clickCount === undefined ) {
        globalThis.clickCount = 0;
      } else {
        globalThis.clickCount += 1;
      }
      if ( globalThis.clickCount >= 2 ) {
        // alert('you found me');
        document.querySelector('#dev_hostname').innerText = window.location.hostname;
        document.querySelector('#footer_menu').style.display = 'block';
      }
    });
  }
}
</script>
<style>
.no-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
#footer_menu {
    display: none;
    border: 1px solid red;
    width: 300px;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
}
#dev_title {
    font-weight: bold;
}
#dev_hostname {
    font-size: 14px;
    font-style: italic;
}
</style>
